module.exports = {"id":"169706","name":"Jack Cork","rating":"78","photo":"./data/images/photos/2/169706.png","club":{"name":"Burnley","logo":"./data/images/clubs/Burnley.png"},"positions":["MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JackCork0.json
// module id = 1862
// module chunks = 0